import { render, staticRenderFns } from "./REgister.vue?vue&type=template&id=42c6583b&scoped=true&"
import script from "./REgister.vue?vue&type=script&lang=js&"
export * from "./REgister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6583b",
  null
  
)

export default component.exports